import EmailEditorToolbar from './EmailEditorToolbar';

export default EmailEditorToolbar;
